import { Home, User, BookOpen, Heart, History, MessageSquare, LogOut, Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useState } from "react";

interface MobileNavProps {
  currentPage?: string;
  onNavigate?: (page: string) => void;
  isLoggedIn?: boolean;
  onLogout?: () => void;
}

const menuItems = [
  { id: "home", label: "首页", sublabel: "ホーム", icon: Home },
  { id: "profile", label: "个人中心", sublabel: "プロフィール", icon: User },
  { id: "vocabulary", label: "生词本", sublabel: "単語帳", icon: BookOpen },
  { id: "favorites", label: "我的收藏", sublabel: "お気に入り", icon: Heart },
  { id: "history", label: "学习记录", sublabel: "履歴", icon: History },
  { id: "feedback", label: "意见反馈", sublabel: "ご意見", icon: MessageSquare },
];

export function MobileNav({ 
  currentPage = "home",
  onNavigate,
  isLoggedIn,
  onLogout
}: MobileNavProps) {
  const [open, setOpen] = useState(false);

  const handleNavigate = (page: string) => {
    onNavigate?.(page);
    setOpen(false);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="h-10 w-10 lg:hidden">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-72 p-0 bg-sidebar">
        {/* Logo */}
        <div className="flex h-16 items-center px-4 border-b border-sidebar-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-hero flex items-center justify-center shadow-lg">
              <span className="text-primary-foreground font-bold text-xl">🍡</span>
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-lg text-sidebar-foreground leading-tight">
                dango
              </span>
              <span className="text-xs text-sidebar-foreground/60">
                用耳朵学日语
              </span>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-4 px-3 space-y-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id;
            
            return (
              <Button
                key={item.id}
                variant="ghost"
                className={cn(
                  "w-full justify-start gap-3 h-12 text-sidebar-foreground/80 hover:text-sidebar-foreground hover:bg-sidebar-accent",
                  isActive && "bg-sidebar-accent text-sidebar-primary font-medium"
                )}
                onClick={() => handleNavigate(item.id)}
              >
                <Icon className={cn("h-5 w-5 shrink-0", isActive && "text-sidebar-primary")} />
                <div className="flex flex-col items-start">
                  <span className="text-sm leading-tight">{item.label}</span>
                  <span className="text-[10px] opacity-60">{item.sublabel}</span>
                </div>
              </Button>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="border-t border-sidebar-border p-3 space-y-2">
          {isLoggedIn && (
            <Button
              variant="ghost"
              className="w-full justify-start gap-3 h-12 text-sidebar-foreground/60 hover:text-destructive hover:bg-sidebar-accent"
              onClick={() => {
                onLogout?.();
                setOpen(false);
              }}
            >
              <LogOut className="h-5 w-5 shrink-0" />
              <span className="text-sm">退出登录</span>
            </Button>
          )}
          <p className="text-[10px] text-sidebar-foreground/50 text-center py-1">
            客服VX：shunlixiezuo168
          </p>
        </div>
      </SheetContent>
    </Sheet>
  );
}
